// ══════════════════════════════════════════════════════════════════════════════
//  src/minigames/pantallaCompleta.js
//  LA PANTALLA COMPLETA DE NEURACINEMA
//
//  ── POR QUE ESTO ESTA APARTE ────────────────────────────────────────────────
//  El mismo bloque de seis lineas estaba copiado en `LibraryScreen`, `DocPlayer`
//  y `MusicPlayerV2`. Tres copias significan que un arreglo hay que hacerlo tres
//  veces, y que la tercera se olvida.
//
//  ── EL PROBLEMA QUE RESUELVE ────────────────────────────────────────────────
//  Las tres copias decian:
//
//      wrap?.requestFullscreen().catch(() => {});
//
//  Ese `catch` vacio es el fallo. `requestFullscreen` sobre un elemento
//  cualquiera NO existe en el Safari del iPhone —solo funciona sobre un <video>—
//  y en cualquier navegador puede rechazarse si el gesto no cuenta como
//  interaccion del usuario.
//
//  Con el catch vacio, el alumno pulsa el boton y NO PASA NADA. Ni cambia la
//  pantalla, ni sale un aviso, ni queda rastro en la consola. Un boton que no
//  hace nada y no explica por que es peor que no tener boton: el alumno lo pulsa
//  tres veces, decide que la app esta rota, y no vuelve a fiarse de ningun otro
//  boton de la pantalla.
//
//  Aqui se hacen dos cosas distintas:
//    · `hayPantallaCompleta()` — para NO PINTAR el boton donde no puede
//      funcionar. Es la mitad importante: el mejor error es el que no existe.
//    · `alternarPantallaCompleta()` — devuelve si lo consiguio, para que quien
//      llama pueda decir algo si falla.
// ══════════════════════════════════════════════════════════════════════════════

const ID_ENVOLTORIO = 'nc-fullscreen-wrap';

/** El nombre del metodo cambia segun el navegador. Se busca el que exista. */
function metodoEntrar(el) {
    if (!el) return null;
    return el.requestFullscreen
        || el.webkitRequestFullscreen
        || el.msRequestFullscreen
        || null;
}

function metodoSalir() {
    return document.exitFullscreen
        || document.webkitExitFullscreen
        || document.msExitFullscreen
        || null;
}

function elementoActual() {
    return document.fullscreenElement || document.webkitFullscreenElement || null;
}

/**
 * ¿Tiene sentido enseñar el boton en este navegador?
 *
 * `fullscreenEnabled` es la respuesta honesta del navegador: dice que no cuando
 * no lo soporta Y cuando lo soporta pero esta prohibido (por ejemplo dentro de
 * un iframe sin permiso). Las dos cosas terminan igual para el alumno.
 */
export function hayPantallaCompleta() {
    if (typeof document === 'undefined') return false;
    const permitido = document.fullscreenEnabled ?? document.webkitFullscreenEnabled ?? false;
    if (!permitido) return false;
    return Boolean(metodoEntrar(document.createElement('div')));
}

/**
 * Entra o sale. Devuelve `true` si el navegador acepto.
 *
 * Se devuelve el resultado en vez de tragarselo para que la pantalla pueda
 * avisar. Un boton que falla en silencio enseña al alumno que la app no
 * responde.
 */
export async function alternarPantallaCompleta() {
    if (typeof document === 'undefined') return false;

    if (elementoActual()) {
        const salir = metodoSalir();
        if (!salir) return false;
        try {
            await salir.call(document);
            return true;
        } catch {
            return false;
        }
    }

    const envoltorio = document.getElementById(ID_ENVOLTORIO);
    const entrar = metodoEntrar(envoltorio);
    if (!entrar) return false;
    try {
        await entrar.call(envoltorio);
        return true;
    } catch {
        // Rechazado: casi siempre porque el navegador no considera este gesto
        // una interaccion valida del usuario.
        return false;
    }
}
